export default {
  metaTitle: "USFans Spreadsheet 2026: Kompletny poradnik i co musisz wiedzieć",
  metaDescription:
    "Kompletny niezależny poradnik o USFans Spreadsheet: czym jest, jak działa, główne kategorie, wskazówki zakupowe, QC, wysyłka i bezpieczeństwo. Aktualizacja 2026.",
  breadcrumbHome: "Strona główna",
  breadcrumbCurrent: "Poradnik USFans Spreadsheet",
  h1: "USFans Spreadsheet 2026: Kompletny poradnik i co musisz wiedzieć",
  shortAnswerLabel: "Krótka odpowiedź",
  shortAnswer:
    "USFans Spreadsheet to uporządkowane źródło produktów, które pomaga odkrywać znaleziska, porównywać kategorie i rozumieć, jak kupować mądrzej — zanim złożysz zamówienie.",
  intro1:
    "Jeśli szukałeś jasnego i uczciwego sposobu na poznanie znalezisk USFans, jesteś we właściwym miejscu. Ten poradnik wyjaśnia, czym jest USFans Spreadsheet, jak działa i jak z niego korzystać, aby podejmować pewniejsze decyzje zakupowe.",
  intro2:
    "Dbamy o to, aby to źródło było niezależne i praktyczne. Nie znajdziesz tu wyolbrzymionych obietnic — tylko proste informacje o kategoriach, QC, wysyłce i bezpieczeństwie, dzięki którym możesz przeglądać z pewnością.",
  tocTitle: "Spis treści",
  toc1: "Czym jest USFans Spreadsheet?",
  toc2: "Jak działa USFans Spreadsheet",
  toc3: "Główne kategorie, które znajdziesz",
  toc4: "Szybki poradnik zakupowy",
  toc5: "Podstawy QC, wysyłki i magazynu",
  toc6: "Czy USFans jest legalny i bezpieczny?",
  s1Title: "Czym jest USFans Spreadsheet?",
  s1Body:
    "USFans Spreadsheet to starannie wyselekcjonowana kolekcja linków do produktów i zasobów, uporządkowana według kategorii. Zamiast przekopywać się przez rozproszone strony, możesz od razu przejść do potrzebnej sekcji — od butów i bluz po torby i akcesoria. Cel jest prosty: sprawić, by odkrywanie produktów było szybsze i mniej mylące.",
  s2Title: "Jak działa USFans Spreadsheet",
  s2Body:
    "Arkusz jest uporządkowany według kategorii, więc zawsze wiesz, gdzie szukać. Wybierz kategorię, przeglądaj dostępne znaleziska i przejdź przez linki na główną stronę, aby zobaczyć aktualne szczegóły, ceny i dostępność. Ponieważ informacje często się zmieniają, zawsze weryfikuj najnowsze szczegóły na podlinkowanych stronach przed zakupem.",
  s3Title: "Główne kategorie, które znajdziesz",
  s3Body:
    "Znajdziesz tu kilkanaście kategorii, w tym Buty, Bluzy i Swetry, Koszulki, Kurtki, Spodnie i Szorty, Nakrycia głowy, Zestawy, Bieliznę, Koszulki sportowe, Akcesoria, Torby, Paski, Perfumy oraz Inne rzeczy. Każda kategoria grupuje podobne produkty, dzięki czemu możesz porównywać opcje bez przełączania się między wieloma kartami.",
  s4Title: "Szybki poradnik zakupowy",
  s4Body:
    "Zanim złożysz zamówienie, wykonaj kilka prostych kroków. Najpierw dokładnie sprawdź zdjęcia produktów. Po drugie, przejrzyj tabelę rozmiarów, jeśli jest dostępna. Po trzecie, porównaj kilka podobnych produktów, zanim się zdecydujesz. Na koniec potwierdź aktualną cenę i szczegóły wysyłki na głównej stronie — mogą się one zmieniać w czasie.",
  s5Title: "Podstawy QC, wysyłki i magazynu",
  s5Body:
    "Wielu kupujących pyta o QC (kontrolę jakości), wysyłkę i obsługę magazynową. W prostych słowach: QC oznacza przeglądanie zdjęć produktów przed ich zatwierdzeniem, wysyłka zależy od wagi, wymiarów i miejsca docelowego, a magazyn to miejsce, w którym produkty są przechowywane i przygotowywane przed wysłaniem do Ciebie. Zrozumienie tych podstaw pomaga uniknąć niespodzianek.",
  s6Title: "Czy USFans jest legalny i bezpieczny?",
  s6Body:
    "To uczciwe pytanie przed każdym zakupem online. Nie składamy absolutnych zapewnień o bezpieczeństwie i żadna platforma nie jest wolna od ryzyka. Najlepsze podejście to weryfikacja szczegółów produktu, sprawdzenie informacji o sprzedawcy, przejrzenie zdjęć QC i zapoznanie się z aktualnymi zasadami przed złożeniem zamówienia. Ostrożność to najskuteczniejszy sposób na ochronę.",
  tableTitle: "Kluczowe funkcje w skrócie",
  tableCol1: "Funkcja",
  tableCol2: "Co warto wiedzieć",
  tableCol3: "Ważna uwaga",
  t1c1: "Odkrywanie produktów",
  t1c2: "Arkusz / zasoby",
  t1c3: "Weryfikuj aktualne informacje",
  t2c1: "QC",
  t2c2: "Zasoby inspekcyjne",
  t2c3: "Dokładnie przeglądaj zdjęcia",
  t3c1: "Wysyłka",
  t3c2: "Wiele czynników",
  t3c3: "Koszty zależą od miejsca docelowego",
  t4c1: "Zwroty",
  t4c2: "Zależne od zasad",
  t4c3: "Sprawdź aktualne warunki",
  faqTitle: "Najczęściej zadawane pytania",
  faq1Q: "Czym jest USFans Spreadsheet?",
  faq1A:
    "To uporządkowane źródło, które grupuje znaleziska produktów USFans według kategorii, ułatwiając przeglądanie i porównywanie opcji w jednym miejscu.",
  faq2Q: "Czy przeglądanie USFans Spreadsheet jest darmowe?",
  faq2A:
    "Samo źródło jest darmowe do przeglądania. Wystarczy sprawdzić główną stronę, aby poznać aktualne szczegóły produktów, ceny i dostępność.",
  faq3Q: "Czy potrzebuję konta, aby korzystać z arkusza?",
  faq3A:
    "Przeglądanie nie wymaga konta. Jeśli zdecydujesz się na zakup, przejdź przez linki na główną stronę i dokończ zamówienie tam.",
  faq4Q: "Jak często arkusz jest aktualizowany?",
  faq4A:
    "Staramy się utrzymywać źródło w porządku i aktualne. Jednak szczegóły produktów często się zmieniają, więc zawsze weryfikuj najnowsze informacje na podlinkowanych stronach.",
  faq5Q: "Czy USFans jest bezpieczny w użyciu?",
  faq5A:
    "Nie możemy zagwarantować bezpieczeństwa żadnej platformy. Zachowaj ostrożność, weryfikuj szczegóły i zapoznaj się z aktualnymi zasadami przed złożeniem zamówienia.",
  ctaTitle: "Kontynuuj odkrywanie",
  ctaSub: "Gotowy do przeglądania? Przejdź na główną stronę lub wróć do strony głównej po więcej poradników.",
  ctaPrimary: "Przeglądaj USFans Spreadsheet",
  ctaSecondary: "Wróć do strony głównej",
  updatedLabel: "Ostatnia aktualizacja:",
  updatedValue: "2026",
  authorLabel: "Napisane i sprawdzone przez zespół redakcyjny USFansSheet",
  disclaimerTitle: "Zastrzeżenie",
  disclaimerBody:
    "Ten artykuł ma charakter wyłącznie informacyjny. USFansSheet to niezależne źródło, które nie jest powiązane z USFans. Zawsze weryfikuj aktualne szczegóły, ceny i zasady na oficjalnych stronach przed dokonaniem zakupu.",
};